<template>
    <v-form>
        <v-row>
            <v-col cols="12">
                <v-text-field
                    label="Code"
                    v-model="form.code"
                    clearable
                    dense
                    outlined
                    hide-details="auto"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PDatePicker
                    v-model="form.from"
                    outlined
                    clearable
                    dense
                    hide
                    label="From">
                </PDatePicker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PDatePicker
                    v-model="form.to"
                    outlined
                    dense
                    clearable
                    hide
                    label="To">
                </PDatePicker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    v-model="form.created_by_id"
                    outlined
                    dense
                    hide-details="auto"
                    label="Created By"
                    clearable
                    @update:search-input="searchUsers"
                    item-text="name"
                    item-value="id"
                    :items="users"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-select
                label="State"
                dense
                outlined
                hide-details="auto"
                v-model="form.state"
                :items="states"
                >

                </v-select>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import debitNote from "./../../services/purchase/debitNote"
import { mapActions, mapGetters } from 'vuex';
import PDatePicker from "./../common/PDatePicker.vue";
import userAPI from './../../services/purchase/user'

export default {
    name: "DebitNoteListSearch",
    components: {
        PDatePicker
    },
    data() {
        return {
            form : {
                code: "",
                reference: "",
                from: null,
                to: null,
                state: null,
                created_by_id: null,
            },
            users: [],
            usersLoading: false,
            states: []
        }
    },
    computed: {
        ...mapGetters({
            params: "purchase/debitNote/params"
        })
    },
    methods: {
        ...mapActions({
            updateParams: "purchase/debitNote/updateParams"
        }),
        submit() {
            this.updateParams(this.form)
        },
        searchUsers(query) {
            this.usersLoading = true;
            userAPI.search(query).then(response => {
                this.users = Array.from(new Set([...this.users, ...response.data]));
            }).finally(() => {
                this.usersLoading = false;
            })
        }
    },
    mounted() {
        this.form = {...this.params}
        debitNote.states().then(response => this.states = response.data)
    }
}
</script>

<style>
</style>